import { Instagram, Youtube } from 'lucide-react';

const SocialMedia = () => {
  const socialLinks = [
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/migayapi/',
      icon: Instagram,
      color: 'hover:text-pink-500'
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/@MigaYapi',
      icon: Youtube,
      color: 'hover:text-red-500'
    }
  ];

  return (
    <div className="flex items-center gap-4">
      {socialLinks.map((social) => {
        const Icon = social.icon;
        return (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`text-gray-400 ${social.color} transition-colors duration-300 hover:scale-110 transform`}
            aria-label={social.name}
          >
            <Icon className="h-6 w-6" />
          </a>
        );
      })}
    </div>
  );
};

export default SocialMedia;
